import { render, staticRenderFns } from "./ManagerCasinoBetReach.vue?vue&type=template&id=2b6d7f77&scoped=true&"
import script from "./ManagerCasinoBetReach.vue?vue&type=script&lang=js&"
export * from "./ManagerCasinoBetReach.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6d7f77",
  null
  
)

export default component.exports